import { useAssignedClientSelection } from "../../../hooks";
import { PumpTrackerAdmin } from "./PumpTrackerAdmin";

export const PumpTrackerClient = () => {
  const { clientOptions, selectedClientId, setSelectedClientId } =
    useAssignedClientSelection();

  return (
    <PumpTrackerAdmin
      clientMode
      assignedClientOptions={clientOptions}
      assignedClientId={selectedClientId}
      onAssignedClientChange={setSelectedClientId}
    />
  );
};
